import Vue from 'vue'

export default ({ carrier }) => {
  return new Vue({
    data () {
      return {
        reports: carrier.collection({
          missing: {}
        })
      }
    }
  })
}